import { withStyles } from '@material-ui/core';

import SortableGallery from './component';
import styles from './styles';

export default withStyles(styles)(SortableGallery);
